import Progress from 'redux-progress';

import {
  GET_CUSTOMER_BY_EMAIL,
  IS_MEMBER_OF_GROUP,
  IS_EMAIL,
  EXTERNAL,
  GET_PARTNER_NAME,
  GET_CONTACTS_FOR_ORGANISATION,
  GET_VALIDATE_COUNTRY_CHANGE,
  POST_ENABLE_DISABLE_MAIN_CONTACT,
  DELETE_CONTACT,
  ADD_NEW_PARTNER_CONTACT,
  PARTNER_EMAIL_CONFIG,
  UPDATE_PARTNER_EMAIL_CONFIG,
} from 'modules/mac/duck/actions/contact';
import type { MACContactAction, MACContactState } from '../models';

export const initialState: MACContactState = {
  getCustomerByEmail: {},
  isMemberOfGroup: Progress.none,
  isEmail: Progress.none,
  external: Progress.none,
  partnerName: {},
  contactsForOrganisation: {},
  validateCountryChange: {},
  deleteContact: Progress.none,
  mainContactEnableDisable: Progress.none,
  addNewPartnerContact: Progress.none,
  partnerEmailConfig: {},
  updatePartnerEmailConfig: Progress.none,
};

export default (
  state: MACContactState = initialState,
  action: MACContactAction,
): MACContactState => {
  switch (action.type) {
    case GET_CUSTOMER_BY_EMAIL:
      return {
        ...state,
        getCustomerByEmail: {
          ...state.getCustomerByEmail,
          [action.email]: action.progress,
        },
      };
    case IS_MEMBER_OF_GROUP:
      return {
        ...state,
        isMemberOfGroup: action.progress,
      };
    case IS_EMAIL:
      return {
        ...state,
        isEmail: action.progress,
      };
    case EXTERNAL:
      return {
        ...state,
        external: action.progress,
      };
    case GET_PARTNER_NAME:
      return {
        ...state,
        partnerName: { ...state.partnerName, [action.partnerId]: action.progress },
      };
    case GET_CONTACTS_FOR_ORGANISATION:
      return {
        ...state,
        contactsForOrganisation: {
          ...state.contactsForOrganisation,
          [action.partnerId]: action.progress,
        },
      };
    case GET_VALIDATE_COUNTRY_CHANGE:
      return {
        ...state,
        validateCountryChange: {
          ...state.validateCountryChange,
          [action.country]: action.progress,
        },
      };
    case POST_ENABLE_DISABLE_MAIN_CONTACT:
      return {
        ...state,
        mainContactEnableDisable: action.progress,
      };
    case DELETE_CONTACT:
      return {
        ...state,
        deleteContact: action.progress,
      };
    case ADD_NEW_PARTNER_CONTACT:
      return {
        ...state,
        addNewPartnerContact: action.progress,
      };
    case PARTNER_EMAIL_CONFIG:
      return {
        ...state,
        partnerEmailConfig: {
          ...state.partnerEmailConfig,
          [action.partnerId]: action.progress,
        },
      };
    case UPDATE_PARTNER_EMAIL_CONFIG:
      return {
        ...state,
        updatePartnerEmailConfig: action.progress,
      };
    default:
      return state;
  }
};
